import { createSlice } from '@reduxjs/toolkit'
import { ProgramInitialState } from '../types'

const initialState: ProgramInitialState = {
  content: null,
  selected: null,
  programId: null,
  totalPages: null,
  pageNumber: null,
  size: null,
}

const programDetailsSlice = createSlice({
  name: 'programHolidays',
  initialState,
  reducers: {
    updateHolidayPrograms: (state, action) => {
      state.pageNumber = action.payload.number
      state.size = action.payload.size
      state.totalPages = action.payload.totalPages
      state.content = action.payload
    },
    updateSelectedHolidayProgram: (state, action) => {
      state.selected = action.payload
    },
    updateCreateHolidayProgram: (state, action) => {
      state.programId = action.payload.id
      state.content = action.payload.data
    },
    resetProgramHoliday: (state) => {
      state.content = null
    },
    resetSelectedHolidayProgram: (state) => {
      state.selected = null
    },
    deleteProgramHolidayAction: (state, action) => {
      state.programId = action.payload.id
    },
    createProgramHolidayAction: () => {
      return
    },
    getSingleProgramHolidayAction: () => {
      return
    },
    updateProgramHolidayAction: () => {
      return
    },
    updateEnableProgramHolidayAction: () => {
      return
    },
    updateDisableProgramHolidayAction: () => {
      return
    },
    getAllProgramsHolidayAction: (state, _action) => {
      return state
    },
    patchToggleUpdateBulkDisableActionProgramHoliday: () => {
      return
    },
    patchToggleUpdateBulkEnableActionProgramHoliday: () => {
      return
    },
  },
})
export const {
  getAllProgramsHolidayAction,
  updateHolidayPrograms,
  updateCreateHolidayProgram,
  deleteProgramHolidayAction,
  updateSelectedHolidayProgram,
  resetProgramHoliday,
} = programDetailsSlice.actions
export default programDetailsSlice.reducer
